import React, { useState, useEffect } from "react";
import "./RangeInput.css";
export default function RangeInput({ action, inputName, min, max, label, refresh, setRefresh, isRefresh=false }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!action.fields[inputName]) {
      action.fields[inputName] = { value: 0 };
    } else {
      setValue(action.fields[inputName].value);
      showSliderValue(action.fields[inputName].value)
    }
  }, [action, refresh]);

  function showSliderValue(val) {
    let rs = document.getElementById("date-rs").clientWidth;
    let configuration = document.getElementById("configuration-container");
    configuration.style.overflow = "hidden";
    let rangeBullet = document.getElementById("date-range-icon");
    let bulletPosition = val / max;
    rangeBullet.style.left = bulletPosition * (rs / 2) + "px";
  }

  const handleChange = (event) => {
    if(event.target.value){
      action.fields[inputName].value = event.target.value;
    }
    showSliderValue(event.target.value);
    setValue(event.target.value);
    if(isRefresh === true)setRefresh(!refresh)
  };
  return (
    <div>
      <div
        className="form-element"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: 10, marginRight: 10 }}>
          {min} {label}
        </span>
        <input
          id="date-rs"
          className="date-range-input"
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
        />

        <span style={{ fontSize: 10, marginLeft: 10 }}>
          +{max} {label}
        </span>
      </div>
      <div id="date-range-slider">
        <div id="date-range-icon">
          <div id="date-range-icon-head" />
          <div id="date-range-icon-body">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {value}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
